// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"Breadcrumb_breadcrumbContainer__goGjN","leftToRight":"Breadcrumb_leftToRight__pziru"};